import { Injectable } from '@angular/core';

type KeysWithDateType<T> = keyof {
    [P in keyof T as T[P] extends Date | null ? P : never]: unknown;
};

@Injectable({
    providedIn: 'root'
})
export default class AutoMapperService {
    static mapToApiModel<Source extends object, Destination extends object>(source: Source): Destination {
        const destination = {} as Destination;

        for (const propertyName in source) {
            const prop = this.camelToSnakeCase(propertyName);
            (destination as any)[prop] = source[propertyName];
        }
        return destination as Destination;
    }

    static mapToApplicationModel<Source extends object, Destination extends object>(source: Source): Destination {
        const destination = {} as Destination;

        for (const propertyName in source) {
            const prop = this.snakeToCamelCase(propertyName);
            (destination as any)[prop] = source[propertyName];
        }
        return destination as Destination;
    }

    static mapToApplicationModelSameCase<Source extends object, Destination extends object>(
        source: Source
    ): Destination {
        const destination = {} as Destination;

        for (const propertyName in source) {
            (destination as any)[propertyName] = source[propertyName];
        }
        return destination as Destination;
    }

    static convertStringsToDates<Source extends object>(
        source: Source,
        ...datePropertyKeys: KeysWithDateType<Source>[]
    ): void {
        datePropertyKeys.forEach(k => {
            const propertyValue: unknown = source[k];
            if (typeof propertyValue !== 'string' || propertyValue === undefined || propertyValue === null) {
                return;
            }

            (source as any)[k] = new Date(propertyValue);
        });
    }

    private static snakeToCamelCase(str: string) {
        return str
            .toLowerCase()
            .replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));
    }

    private static camelToSnakeCase(str: string) {
        return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    }
}
